import { motion } from "framer-motion";

export const Intro = ({ onDone }) => {
  const dx = typeof window !== "undefined" ? 56 - window.innerWidth / 2 : 0;
  const dy = typeof window !== "undefined" ? 32 - window.innerHeight / 2 : 0;

  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-cream flex items-center justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.45, ease: "easeOut" } }}
      data-testid="intro-overlay"
    >
      <motion.img
        src="/logo.png"
        alt="Cestou Recordações"
        className="w-52 sm:w-72"
        initial={{ opacity: 0, scale: 0.45, x: 0, y: 0 }}
        animate={{
          opacity: [0, 1, 1, 1],
          scale: [0.45, 1, 1, 0.14],
          x: [0, 0, 0, dx],
          y: [0, 0, 0, dy],
        }}
        transition={{ duration: 2.2, times: [0, 0.32, 0.55, 1], ease: "easeInOut" }}
        onAnimationComplete={onDone}
        data-testid="intro-logo"
      />
    </motion.div>
  );
};
